import { render, staticRenderFns } from "./ImageFileUploader.vue?vue&type=template&id=2775e9e6&scoped=true&"
import script from "./ImageFileUploader.vue?vue&type=script&lang=ts&"
export * from "./ImageFileUploader.vue?vue&type=script&lang=ts&"
import style0 from "./ImageFileUploader.vue?vue&type=style&index=0&id=2775e9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2775e9e6",
  null
  
)

export default component.exports